import { MessageCircle } from "lucide-react";

// WhatsApp support number (Brazil DDI 55)
const WHATSAPP_NUMBER = "5569993316604";

export default function SupportButton() {
  const message = encodeURIComponent("Olá! Preciso de ajuda com o CarnesWork.");
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer"
       data-testid="btn-whatsapp-support"
       className="fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-30 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_25px_-5px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform opacity-80 hover:opacity-100"
       aria-label="Suporte via WhatsApp">
      <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6" />
    </a>
  );
}
